var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoEnable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.139,
    height: 26.664,
    viewBox: "0 0 27.447 15.338",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6706",
    "data-name": "Group 6706",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M-1604.333-2250.073l-4.143,2.735a3.478,3.478,0,0,0-3.428-2.9h-12.352a3.478,3.478,0,0,0-3.478,3.478v8.315a3.478,3.478,0,0,0,3.478,3.478h12.352a3.477,3.477,0,0,0,3.474-3.34l4.1,2.7a1.5,1.5,0,0,0,2.24-1.48v-11.512A1.5,1.5,0,0,0-1604.333-2250.073Z",
    transform: "translate(1627.734 2250.304)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_767",
    "data-name": "Rectangle 767",
    width: 1.009,
    height: 14.798,
    rx: 0.505,
    transform: "translate(26.438 0.068)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoEnable);
export default __webpack_public_path__ + "static/media/VideoEnable.800e2ef76ba16bc2b9e96b607a569651.svg";
export { ForwardRef as ReactComponent };